import * as React from 'react';
import WorkflowInstanceState from '../../../models/WorkflowInstanceState';
import { Modal, ModalBody, ModalHeader } from '@emorg-prd/standard-react';
import Table from '../components/Table';
import './WorkflowHistoryModal.css';
import StandardModal from './StandardModal';

interface WorkflowHistoryModalProps {
	visible: boolean;
	onClose: () => void;
	workflowInstanceStates: WorkflowInstanceState[];
}

const WorkflowHistoryModal: React.FC<WorkflowHistoryModalProps> = ({ visible, onClose, workflowInstanceStates }) => {
	const [statesOnPage, setStatesOnPage] = React.useState<WorkflowInstanceState[]>([]);

	const tableRows = [...workflowInstanceStates].reverse().map((state) => (
		<Table.Body key={state.workflowInstanceId}>
			<div className="em-u-text-align-center">
				{state.performedOnDate ? new Date(state.performedOnDate).toLocaleString() : 'N/A'}
			</div>
			<div className="em-u-text-align-center">
				{state.action ? state.action.charAt(0).toUpperCase() + state.action.slice(1) : ''}
			</div>
			<div className="em-u-text-align-center">{state.performedByUser?.displayName}</div>
			<div className="em-u-text-align-center">
				{state.performedReason
					? state.performedReason.charAt(0).toUpperCase() + state.performedReason.slice(1)
					: ''}
			</div>
			<div className="em-u-text-align-center">{state.workflowState?.name}</div>
		</Table.Body>
	));

	if (!visible) {
		return null;
	}

	return (
		<StandardModal
			show={visible}
			onDismiss={onClose}
			title="Workflow History"
			size='em-c-modal--large'
		>
			<Table>
				<Table.Head>
					<Table.Head.Row>
						<Table.Head.Cell>Date</Table.Head.Cell>
						<Table.Head.Cell>Action</Table.Head.Cell>
						<Table.Head.Cell>Performed By</Table.Head.Cell>
						<Table.Head.Cell>Comment</Table.Head.Cell>
						<Table.Head.Cell>Send to</Table.Head.Cell>
					</Table.Head.Row>
				</Table.Head>
				<Table.Body>{tableRows}</Table.Body>
			</Table>
		</StandardModal>
	);
};
export default WorkflowHistoryModal;
